import React from "react";

export default function LoadingSkeleton() {
    return (
        <div className="animate-pulse space-y-6">
            {[...Array(5)].map((_, i) => (
                <div key={i} className="space-y-3">
                    <div className="h-5 bg-paper-deep/40 rounded w-full"/>
                    <div className="h-5 bg-paper-deep/40 rounded w-[95%]"/>
                    <div className="h-5 bg-paper-deep/40 rounded w-[88%]"/>
                    <div className="h-5 bg-paper-deep/30 rounded w-[70%]"/>
                </div>
            ))}
        </div>
    );
}
